export const DATA_MINIMA = new Date(1900, 1, 1);
